import { render, staticRenderFns } from "./SelfPublishingBooks.vue?vue&type=template&id=026a0510&"
import script from "./SelfPublishingBooks.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingBooks.vue?vue&type=script&lang=js&"
import style0 from "./SelfPublishingBooks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports